import React, { useState } from "react";
import { vidhiEntry } from "../services/apiservice"; // Import API function
import "./DharmikSankalpana.scss";
import donationImage from "../assets/images/qrcbackground.png";
import successGif from "../assets/images/namastehands.jpg"; // Import your success GIF
import donationvideo from "../../src/assets/videos/dengivideo.mp4"


const DharmikSankalpana = () => {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    requestfor: "",
    stayingplace: "",
  });

  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [showPopup, setShowPopup] = useState(false); // State for success popup

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {

    e.preventDefault();
    setMessage(null);
    setError(null);

    try {
      const response = await vidhiEntry(formData);
      setShowPopup(true); // Show success popup

      // Hide popup after 5 seconds
      setTimeout(() => {
        setShowPopup(false);
      }, 10000);

      setFormData({ name: "", mobile: "", requestfor: "", stayingplace: ""}); // Reset form
    } catch (error) {
      setError(error.response?.data?.message || "Something went wrong. Please try again.");
    }
  };

  return (
    <div className="donationcontainer">
    <div className="donation-container">
      <div className="background-image"></div>
      <div className="pratishthavideo">
        <video controls autoPlay loop >
          <source src={donationvideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="content">
        <div className="header">
        <h1>धार्मिक संकल्प</h1>
          <p className="donation-text" style={{fontSize:"16px"}}>
            आपणास कोणतीही विधि करायाची आसल्यास खलीला फॉर्म भरावा.
          </p>
        </div>

        {/* Success Popup */}
        {showPopup && (
          <div className="success-popup">
            <img src={successGif} alt="Success" style={{ width: "300px" }} />
            <p style={{fontSize:"18px"}}>आपली विनंती नोंद करण्यात आली आहे!</p>
          </div>
        )}

        {message && <p className="success-message">{message}</p>}
        {error && <p className="error-message">{error}</p>}

        {/* Donation Form */}
        {!showPopup && (
          <div className="formandvideo">
            <form onSubmit={handleSubmit} className="donation-form">
              <input type="text" name="name" placeholder="नाव" required value={formData.name} onChange={handleChange} />
              <input type="text" name="mobile" placeholder="मोबाईल" required value={formData.mobile} onChange={handleChange} />

              <select name="requestfor" required value={formData.requestfor} onChange={handleChange} className="donation-dropdown">
                <option value="" disabled hidden>
                विधि निवडा
                </option>
                <option value="दत्तयाग">दत्तयाग</option>
                <option value="गुरु चरित्र पारायण">गुरु चरित्र पारायण</option>
              </select>

              <select name="stayingplace" required value={formData.stayingplace} onChange={handleChange} className="donation-dropdown">
                <option value="" disabled hidden>
                राहण्याचा पर्याय
                </option>
                <option value="मंदिर मुक्काम">मंदिर मुक्काम</option>
                <option value="बहेरगाव मुक्कम">बहेरगाव मुक्कम</option>
              </select>


              <button type="submit">विनंती करा</button>
            </form>
          </div>)}

        {/* QR Code Image */}
        <img src={donationImage} alt="Donation QR" className="donation-image" style={{ width: "300px" }} />
      </div>
    </div>
    <div className="mobile-donation-container">
      <div className="background-image"></div>
      <div className="pratishthavideo">
        <video controls autoPlay loop >
          <source src={donationvideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div className="content">
        <div className="header">
        <h1>धार्मिक संकल्प</h1>
          <p className="donation-text" style={{fontSize:"16px"}}>
            आपणास कोणतीही विधि करायाची आसल्यास खलीला फॉर्म भरावा.
          </p>
        </div>

        {/* Success Popup */}
        {showPopup && (
          <div className="success-popup">
            <img src={successGif} alt="Success" style={{ width: "300px" }} />
            <p style={{fontSize:"18px"}}>आपली विनंती नोंद करण्यात आली आहे!</p>
          </div>
        )}

        {message && <p className="success-message">{message}</p>}
        {error && <p className="error-message">{error}</p>}

        {/* Donation Form */}
        {!showPopup && (
          <div className="formandvideo">
            <form onSubmit={handleSubmit} className="donation-form">
              <input type="text" name="name" placeholder="नाव" required value={formData.name} onChange={handleChange} />
              <input type="text" name="mobile" placeholder="मोबाईल" required value={formData.mobile} onChange={handleChange} />

              <select name="requestfor" required value={formData.requestfor} onChange={handleChange} className="donation-dropdown">
                <option value="" disabled hidden>
                विधि निवडा
                </option>
                <option value="दत्तयाग">दत्तयाग</option>
                <option value="गुरु चरित्र पारायण">गुरु चरित्र पारायण</option>
              </select>

              <select name="stayingplace" required value={formData.stayingplace} onChange={handleChange} className="donation-dropdown">
                <option value="" disabled hidden>
                राहण्याचा पर्याय
                </option>
                <option value="मंदिर मुक्काम">मंदिर मुक्काम</option>
                <option value="बहेरगाव मुक्कम">बहेरगाव मुक्कम</option>
              </select>


              <button type="submit">विनंती करा</button>
            </form>
          </div>)}

        {/* QR Code Image */}
        <img src={donationImage} alt="Donation QR" className="donation-image" style={{ width: "300px" }} />
      </div>
    </div>
    </div>
  );
};

export default DharmikSankalpana;
